"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORD_TYPES = exports.WORD_MODES = exports.Parameter = void 0;
class Parameter {
    prepare(dictionary) {
        this.suggesters = this.createSuggesters(dictionary);
        for (const suggester of this.suggesters) {
            suggester.prepare();
        }
    }
    presuggest(dictionary) {
        const suggestions = [];
        if (this.suggesters !== undefined) {
            for (const suggester of this.suggesters) {
                suggestions.push(...suggester.presuggest(dictionary));
            }
        }
        return suggestions;
    }
    suggest(word, dictionary) {
        const suggestions = [];
        if (this.suggesters !== undefined) {
            for (const suggester of this.suggesters) {
                suggestions.push(...suggester.suggest(word, dictionary));
            }
        }
        return suggestions;
    }
    static createCandidates(word, mode, language) {
        var _a, _b, _c;
        if (mode === "name") {
            return [word.name];
        }
        else if (mode === "equivalent") {
            return (_a = word.equivalentNames[language]) !== null && _a !== void 0 ? _a : [];
        }
        else if (mode === "both") {
            return [word.name, ...((_b = word.equivalentNames[language]) !== null && _b !== void 0 ? _b : [])];
        }
        else if (mode === "content") {
            return [(_c = word.contents[language]) !== null && _c !== void 0 ? _c : ""];
        }
        else {
            throw new Error("cannot happen");
        }
    }
    static createMatcher(type) {
        if (type === "exact") {
            const matcher = function (text, candidate) {
                return candidate === text;
            };
            return matcher;
        }
        else if (type === "prefix") {
            const matcher = function (text, candidate) {
                return candidate.startsWith(text);
            };
            return matcher;
        }
        else if (type === "suffix") {
            const matcher = function (text, candidate) {
                return candidate.endsWith(text);
            };
            return matcher;
        }
        else if (type === "part") {
            const matcher = function (text, candidate) {
                return candidate.includes(text);
            };
            return matcher;
        }
        else if (type === "pair") {
            const matcher = function (text, candidate) {
                try {
                    if (text.length <= 10) {
                        let predicate = false;
                        for (let i = 0; i < text.length; i++) {
                            const beforeText = text.substring(0, i);
                            const afterText = text.substring(i + 1);
                            const regexp = new RegExp("^" + beforeText + "." + afterText + "$");
                            if (candidate.match(regexp) !== null) {
                                predicate = true;
                                break;
                            }
                        }
                        return predicate;
                    }
                    else {
                        return false;
                    }
                }
                catch (error) {
                    return false;
                }
            };
            return matcher;
        }
        else if (type === "regular") {
            const matcher = function (text, candidate) {
                try {
                    const regexp = new RegExp(text, "m");
                    return candidate.match(regexp) !== null;
                }
                catch (error) {
                    return false;
                }
            };
            return matcher;
        }
        else {
            throw new Error("cannot happen");
        }
    }
}
exports.Parameter = Parameter;
exports.WORD_MODES = ["name", "equivalent", "both", "content"];
exports.WORD_TYPES = ["exact", "prefix", "suffix", "part", "pair", "regular"];
